// PlaygroundEditor.js - Editing: Albaran
// Entity Type UUID: abbf8017-e4d8-4c70-bbee-e126474c01be
// Push changes: ./scripts/push_entity_ui.sh abbf8017-e4d8-4c70-bbee-e126474c01be <token>

export const ENTITY_TYPE_UUID = "abbf8017-e4d8-4c70-bbee-e126474c01be"

export const INITIAL_DATA = {}

export const JSON_SCHEMA = {"type":"object","title":"Albarán","required":["number","date","issuer","recipient","lines","state","pdf_url","pdf_path","invoice_uuid","total","error_message"],"properties":{"date":{"type":"string","title":"Fecha"},"lines":{"type":"array","items":{"type":"object","title":"Línea","required":["product_code","concept","quantity","unit_price","discount","tax_percent","tax_amount","total"],"properties":{"total":{"type":"number","title":"Total"},"concept":{"type":"string","title":"Concepto"},"discount":{"type":"number","title":"Descuento"},"quantity":{"type":"number","title":"Cantidad"},"tax_amount":{"type":"number","title":"Impuestos"},"unit_price":{"type":"number","title":"Precio Unitario"},"tax_percent":{"type":"number","title":"% Impuestos"},"product_code":{"type":"string","title":"Código Producto"}}},"title":"Líneas"},"state":{"type":"string","title":"Estado"},"total":{"type":"number","title":"Total"},"issuer":{"type":"object","title":"Emisor","required":["nif","name"],"properties":{"nif":{"type":"string","title":"CIF"},"name":{"type":"string","title":"Nombre"}}},"number":{"type":"string","title":"Número"},"pdf_url":{"type":"string","title":"PDF URL (NO RELLENAR)"},"pdf_path":{"type":"string","title":"PDF PATH (NO RELLENAR)"},"recipient":{"type":"object","title":"Receptor","required":["nif","name"],"properties":{"nif":{"type":"string","title":"CIF"},"name":{"type":"string","title":"Nombre"}}},"invoice_uuid":{"type":"string","title":"UUID Factura (NO RELLENAR)"},"error_message":{"type":"string","title":"Mensaje de Error"},"notes":{"type":"string","title":"Notas"}}}

export const TEMPLATE_STRING = `<div style="display: flex; width: 100%;">
  <!-- Panel principal del formulario -->
  <v-card :style="showPdfPanel ? 'flex: 1; min-width: 0; transition: all 0.3s ease;' : 'flex: 1; transition: all 0.3s ease;'">
  <v-card-title class="d-flex align-center py-2">
    <v-btn
      icon
      small
      @click="run_action('back')"
      :disabled="saving"
      class="mr-2"
      title="Volver"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <span class="text-h6">Albarán {{ localData.number }}</span>
    <v-btn
      v-if="localData.pdf_url"
      small
      :text="!showPdfPanel"
      :outlined="showPdfPanel"
      :color="showPdfPanel ? 'primary' : 'primary'"
      class="ml-2"
      @click="togglePdfPanel"
    >
      <v-icon small left>{{ showPdfPanel ? 'mdi-chevron-right' : 'mdi-file-pdf-box' }}</v-icon>
      {{ showPdfPanel ? 'Ocultar PDF' : 'Ver PDF' }}
    </v-btn>
    <v-spacer></v-spacer>
    <v-btn
      v-if="showPrev"
      icon
      small
      @click="run_action('prev')"
      :disabled="saving"
      color="primary"
      title="Anterior"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-btn
      v-if="showNext"
      icon
      small
      @click="run_action('next')"
      :disabled="saving"
      color="primary"
      title="Siguiente"
      class="mr-2"
    >
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
    <span class="text-body-2 mr-4" :style="'color:' + stateColor">
      <v-icon small :color="stateColor" class="mr-1">{{ stateIcon }}</v-icon>
      {{ stateLabel }}
    </span>
    <v-btn
      v-if="localData.state === 'draft'"
      small
      outlined
      :color="hasErrors ? 'warning' : 'success'"
      @click="confirmValidar"
      :disabled="saving"
      class="mr-2"
    >
      <v-icon small left>mdi-check</v-icon>
      Validar
    </v-btn>
    <v-btn
      v-if="localData.state === 'draft'"
      icon
      small
      color="primary"
      @click="handleSave"
      :loading="saving"
      :disabled="saving"
      title="Guardar"
    >
      <v-icon>mdi-content-save</v-icon>
    </v-btn>
  </v-card-title>
  <v-divider></v-divider>
  <v-card-text class="pa-4">
    <!-- Error message at top -->
    <div v-if="localData.error_message" class="mb-3" style="color: #f44336; font-size: 13px;">
      <v-icon small color="error" class="mr-1">mdi-alert-circle</v-icon>
      {{ localData.error_message }}
    </div>

    <!-- Información General -->
    <v-row dense>
      <v-col cols="3">
        <v-text-field
          :value="localData.number"
          @input="val => { localData.number = val; update(); }"
          label="Número"
          outlined
          dense
          hide-details
          :readonly="isReadonly"
        ></v-text-field>
      </v-col>
      <v-col cols="3">
        <v-text-field
          :value="dateForInput"
          @input="val => { setDateFromInput(val); }"
          label="Fecha"
          type="date"
          outlined
          dense
          hide-details
          :readonly="isReadonly"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row dense class="mt-3">
      <v-col cols="6">
        <div class="text-caption grey--text mb-1">EMISOR</div>
        <v-row dense>
          <v-col cols="4">
            <v-text-field
              :value="localData.issuer ? localData.issuer.nif : ''"
              @input="val => { if (!localData.issuer) { \$set(localData, 'issuer', {}); } localData.issuer.nif = val; update(); }"
              label="CIF"
              outlined
              dense
              hide-details
              :readonly="isReadonly"
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <v-text-field
              :value="localData.issuer ? localData.issuer.name : ''"
              @input="val => { if (!localData.issuer) { \$set(localData, 'issuer', {}); } localData.issuer.name = val; update(); }"
              label="Nombre"
              outlined
              dense
              hide-details
              :readonly="isReadonly"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="6">
        <div class="text-caption grey--text mb-1">RECEPTOR</div>
        <v-row dense>
          <v-col cols="4">
            <v-text-field
              :value="localData.recipient ? localData.recipient.nif : ''"
              @input="val => { if (!localData.recipient) { \$set(localData, 'recipient', {}); } localData.recipient.nif = val; update(); }"
              label="CIF"
              outlined
              dense
              hide-details
              :readonly="isReadonly"
            ></v-text-field>
          </v-col>
          <v-col cols="8">
            <v-text-field
              :value="localData.recipient ? localData.recipient.name : ''"
              @input="val => { if (!localData.recipient) { \$set(localData, 'recipient', {}); } localData.recipient.name = val; update(); }"
              label="Nombre"
              outlined
              dense
              hide-details
              :readonly="isReadonly"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Líneas -->
    <div class="mt-4">
      <table style="width: 100%; border-collapse: collapse; font-size: 13px;">
        <thead>
          <tr style="background: #f5f5f5;">
            <th style="text-align: left; padding: 10px 8px; border-bottom: 2px solid #ddd; font-weight: 600; width: 100px;">Código</th>
            <th style="text-align: left; padding: 10px 8px; border-bottom: 2px solid #ddd; font-weight: 600;">Concepto</th>
            <th style="text-align: right; padding: 10px 8px; border-bottom: 2px solid #ddd; font-weight: 600; width: 80px;">Cant.</th>
            <th style="text-align: right; padding: 10px 8px; border-bottom: 2px solid #ddd; font-weight: 600; width: 100px;">P. Unit.</th>
            <th style="text-align: right; padding: 10px 8px; border-bottom: 2px solid #ddd; font-weight: 600; width: 80px;">Dto.</th>
            <th style="text-align: right; padding: 10px 8px; border-bottom: 2px solid #ddd; font-weight: 600; width: 70px;">% IVA</th>
            <th style="text-align: right; padding: 10px 8px; border-bottom: 2px solid #ddd; font-weight: 600; width: 90px;">IVA</th>
            <th style="text-align: right; padding: 10px 8px; border-bottom: 2px solid #ddd; font-weight: 600; width: 100px;">Total</th>
            <th v-if="!isReadonly" style="width: 50px; border-bottom: 2px solid #ddd;"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(line, index) in linesArray" :key="index"
              :style="'border-bottom: 1px solid #eee;' + (hasLineError(line) ? 'background-color: #fff8f8;' : (index % 2 === 0 ? '' : 'background: #fafafa;'))">
            <td style="padding: 4px 8px;">
              <input
                type="text"
                :value="line.product_code"
                @input="e => { line.product_code = e.target.value; update(); }"
                :readonly="isReadonly"
                placeholder="Código"
                style="width: 100%; border: none; background: transparent; padding: 6px 0; outline: none; font-size: 13px;"
              />
            </td>
            <td style="padding: 4px 8px;">
              <input
                type="text"
                :value="line.concept"
                @input="e => { line.concept = e.target.value; update(); }"
                :readonly="isReadonly"
                placeholder="Descripción"
                style="width: 100%; border: none; background: transparent; padding: 6px 0; outline: none; font-size: 13px;"
              />
            </td>
            <td style="padding: 4px 8px;">
              <input
                type="text"
                inputmode="decimal"
                :value="line.quantity"
                @input="e => { line.quantity = parseNumber(e.target.value); update(); }"
                :readonly="isReadonly"
                style="width: 100%; border: none; background: transparent; padding: 6px 0; outline: none; text-align: right; font-size: 13px;"
              />
            </td>
            <td style="padding: 4px 8px;">
              <div style="display: flex; align-items: center; justify-content: flex-end;">
                <input
                  type="text"
                  inputmode="decimal"
                  :value="line.unit_price"
                  @input="e => { line.unit_price = parseNumber(e.target.value); update(); }"
                  :readonly="isReadonly"
                  style="width: 70px; border: none; background: transparent; padding: 6px 0; outline: none; text-align: right; font-size: 13px;"
                />
                <span style="font-size: 13px; color: #9e9e9e; margin-left: 2px;">€</span>
              </div>
            </td>
            <td style="padding: 4px 8px;">
              <div style="display: flex; align-items: center; justify-content: flex-end;">
                <input
                  type="text"
                  inputmode="decimal"
                  :value="line.discount"
                  @input="e => { line.discount = parseNumber(e.target.value); update(); }"
                  :readonly="isReadonly"
                  style="width: 60px; border: none; background: transparent; padding: 6px 0; outline: none; text-align: right; font-size: 13px;"
                />
                <span style="font-size: 13px; color: #9e9e9e; margin-left: 2px;">€</span>
              </div>
            </td>
            <td style="padding: 4px 8px;">
              <div style="display: flex; align-items: center; justify-content: flex-end;">
                <input
                  type="text"
                  inputmode="decimal"
                  :value="line.tax_percent"
                  @input="e => { line.tax_percent = parseNumber(e.target.value); update(); }"
                  :readonly="isReadonly"
                  style="width: 50px; border: none; background: transparent; padding: 6px 0; outline: none; text-align: right; font-size: 13px;"
                />
                <span style="font-size: 13px; color: #9e9e9e; margin-left: 2px;">%</span>
              </div>
            </td>
            <td style="padding: 4px 8px;" :style="!isTaxesValid(line) ? 'background: #ffebee;' : ''">
              <div style="display: flex; align-items: center; justify-content: flex-end;">
                <span v-if="!isReadonly && !isTaxesValid(line)" style="font-size: 10px; color: #9e9e9e; margin-right: 4px;">
                  ({{ calculateExpectedTaxes(line).toFixed(2) }})
                  <v-icon
                    x-small
                    color="primary"
                    style="cursor: pointer;"
                    title="Aplicar IVA calculado"
                    @click="correctLineTaxes(line)"
                  >mdi-calculator</v-icon>
                </span>
                <input
                  type="text"
                  inputmode="decimal"
                  :value="line.tax_amount"
                  @input="e => { line.tax_amount = parseNumber(e.target.value); update(); }"
                  :readonly="isReadonly"
                  style="width: 60px; border: none; background: transparent; padding: 6px 0; outline: none; text-align: right; font-size: 13px;"
                />
                <span style="font-size: 13px; color: #9e9e9e; margin-left: 2px;">€</span>
              </div>
            </td>
            <td style="padding: 4px 8px; font-weight: 600;" :style="!isTotalValid(line) ? 'background: #ffebee;' : ''">
              <div style="display: flex; align-items: center; justify-content: flex-end;">
                <span v-if="!isReadonly && !isTotalValid(line)" style="font-size: 10px; color: #9e9e9e; margin-right: 4px;">
                  ({{ calculateExpectedTotal(line).toFixed(2) }})
                  <v-icon
                    x-small
                    color="primary"
                    style="cursor: pointer;"
                    title="Aplicar total calculado"
                    @click="correctLineTotal(line)"
                  >mdi-calculator</v-icon>
                </span>
                <input
                  type="text"
                  inputmode="decimal"
                  :value="line.total"
                  @input="e => { line.total = parseNumber(e.target.value); update(); }"
                  :readonly="isReadonly"
                  style="width: 70px; border: none; background: transparent; padding: 6px 0; outline: none; text-align: right; font-size: 13px; font-weight: 600;"
                />
                <span style="font-size: 13px; font-weight: 600; margin-left: 2px;">€</span>
              </div>
            </td>
            <td v-if="!isReadonly" style="padding: 4px; text-align: center;">
              <v-btn icon x-small color="grey" @click="removeLine(index)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr v-if="!isReadonly" @click="addLine" style="cursor: pointer; border-bottom: 1px solid #eee;" class="add-row">
            <td colspan="9" style="padding: 8px; text-align: center; color: #9e9e9e;">
              <v-icon small color="grey" class="mr-1">mdi-plus</v-icon>
              <span style="font-size: 12px;">Añadir línea</span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr style="background: #f5f5f5; border-top: 2px solid #ddd;">
            <td colspan="7" style="text-align: right; padding: 12px 8px; font-weight: 600;">
              Total
              <span v-if="totalMismatch" style="font-weight: 400; font-size: 11px; color: #9e9e9e; margin-left: 8px;">
                ({{ formatCurrency(totalGeneral) }})
                <v-icon
                  v-if="!isReadonly"
                  small
                  color="primary"
                  style="cursor: pointer; margin-left: 4px;"
                  title="Aplicar suma de líneas"
                  @click="correctTotal"
                >mdi-calculator</v-icon>
              </span>
            </td>
            <td style="padding: 8px;" :style="totalMismatch ? 'background: #ffebee;' : ''">
              <div style="display: flex; align-items: center; justify-content: flex-end;">
                <input
                  type="text"
                  inputmode="decimal"
                  :value="localData.total"
                  @input="e => { localData.total = parseNumber(e.target.value); update(); }"
                  :readonly="isReadonly"
                  style="width: 80px; border: none; background: transparent; padding: 6px 0; outline: none; text-align: right; font-size: 15px; font-weight: 700;"
                  :style="totalMismatch ? 'color: #f44336;' : 'color: #4caf50;'"
                />
                <span style="font-size: 15px; font-weight: 700; margin-left: 4px;" :style="totalMismatch ? 'color: #f44336;' : 'color: #4caf50;'">€</span>
              </div>
            </td>
            <td v-if="!isReadonly"></td>
          </tr>
        </tfoot>
      </table>

      <v-alert v-if="hasLineErrors" type="warning" dense text class="mt-3">
        Hay líneas con errores de cálculo. Revisa los campos marcados en rojo.
      </v-alert>

    </div>

    <!-- Notas libres (siempre editable) -->
    <div class="mt-4">
      <v-textarea
        :value="localData.notes"
        @input="val => { localData.notes = val; update(); }"
        label="Notas"
        outlined
        dense
        rows="3"
        hide-details
        placeholder="Añade notas o comentarios..."
      ></v-textarea>
    </div>

    <!-- Dialog de confirmación -->
    <v-dialog v-model="showConfirmDialog" max-width="400" persistent>
      <v-card>
        <v-card-title class="text-h6">
          <v-icon left :color="hasErrors ? 'warning' : 'success'">mdi-alert-circle</v-icon>
          Confirmar validación
        </v-card-title>
        <v-card-text>
          <p v-if="hasErrors" class="mb-2" style="color: #ff9800;">
            <v-icon small color="warning" class="mr-1">mdi-alert</v-icon>
            El albarán tiene errores de cálculo.
          </p>
          <p class="mb-0">El albarán no será editable después de validar.</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text small @click="showConfirmDialog = false">Cancelar</v-btn>
          <v-btn small outlined :color="hasErrors ? 'warning' : 'success'" @click="doValidar">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-text>
</v-card>

  <!-- Panel lateral del PDF -->
  <div v-if="showPdfPanel && localData.pdf_url" style="width: 50%; min-width: 400px; max-width: 700px; border-left: 1px solid #e0e0e0; display: flex; flex-direction: column; background: #fafafa; transition: all 0.3s ease;">
    <div style="padding: 8px 16px; background: #f5f5f5; border-bottom: 1px solid #e0e0e0; display: flex; align-items: center; justify-content: space-between;">
      <span style="font-weight: 500; font-size: 14px; color: #424242;">
        <v-icon small class="mr-1">mdi-file-pdf-box</v-icon>
        PDF del Albarán
      </span>
      <div>
        <v-btn icon x-small @click="openPdfNewTab" title="Abrir en nueva pestaña">
          <v-icon small>mdi-open-in-new</v-icon>
        </v-btn>
        <v-btn icon x-small @click="togglePdfPanel" title="Cerrar panel">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
    <div style="flex: 1; overflow: auto; padding: 8px;">
      <PDFEmbed :src="localData.pdf_url" />
    </div>
  </div>
</div>`

export const COMPONENT_OPTIONS = `{
  data: function() {
    return {
      tolerance: 0.01,
      showConfirmDialog: false,
      showPdfPanel: false,
      saving: false,
      pollingInterval: null
    };
  },
  computed: {
    isReadonly: function() {
      return this.localData.state !== 'draft';
    },
    // Convert dd/mm/yyyy to yyyy-mm-dd for the date input
    dateForInput: function() {
      const date = this.localData.date || '';
      if (!date) return '';
      // Check if already in yyyy-mm-dd format
      if (date.match(/^d{4}-d{2}-d{2}\$/)) {
        return date;
      }
      // Convert from dd/mm/yyyy to yyyy-mm-dd
      const parts = date.split('/');
      if (parts.length === 3) {
        return parts[2] + '-' + parts[1] + '-' + parts[0];
      }
      return date;
    },
    stateLabel: function() {
      const labels = {
        draft: 'Borrador',
        validated: 'Validado',
        invoiced: 'Facturado',
        error: 'Error'
      };
      return labels[this.localData.state] || this.localData.state;
    },
    stateColor: function() {
      const colors = {
        draft: '#9e9e9e',
        validated: '#4caf50',
        invoiced: '#1976d2',
        error: '#f44336'
      };
      return colors[this.localData.state] || '#9e9e9e';
    },
    stateIcon: function() {
      const icons = {
        draft: 'mdi-pencil',
        validated: 'mdi-check',
        invoiced: 'mdi-file-document',
        error: 'mdi-alert-circle'
      };
      return icons[this.localData.state] || 'mdi-help';
    },
    linesArray: function() {
      if (!this.localData.lines || !Array.isArray(this.localData.lines)) {
        return [];
      }
      return this.localData.lines;
    },
    totalTaxAmount: function() {
      return this.linesArray.reduce((sum, line) => sum + (parseFloat(line.tax_amount) || 0), 0);
    },
    totalGeneral: function() {
      return this.linesArray.reduce((sum, line) => sum + (parseFloat(line.total) || 0), 0);
    },
    // Calculate what the total SHOULD be based on line calculations (base + taxes)
    totalGeneralCalculated: function() {
      return this.linesArray.reduce((sum, line) => sum + this.calculateExpectedTotal(line), 0);
    },
    hasLineErrors: function() {
      return this.linesArray.some(line => this.hasLineError(line));
    },
    totalMismatch: function() {
      return Math.abs((this.localData.total || 0) - this.totalGeneral) > this.tolerance;
    },
    // Check if total mismatches the calculated total (base + taxes for all lines)
    totalMismatchCalculated: function() {
      return Math.abs((this.localData.total || 0) - this.totalGeneralCalculated) > this.tolerance;
    },
    hasErrors: function() {
      return this.hasLineErrors || this.totalMismatch;
    }
  },
  async mounted(){
    // Inject CSS to hide number input spinners
    if (!document.getElementById('hide-number-spinners')) {
      const style = document.createElement('style');
      style.id = 'hide-number-spinners';
      style.textContent = \`
        input[type="number"]::-webkit-inner-spin-button,
        input[type="number"]::-webkit-outer-spin-button {
          -webkit-appearance: none !important;
          appearance: none !important;
          margin: 0 !important;
        }
        input[type="number"] {
          -moz-appearance: textfield !important;
          appearance: textfield !important;
        }
      \`;
      document.head.appendChild(style);
    }
    console.log('PlaygroundEditor mounted, spinner styles injected');

    if (this.localData.pdf_path) {
      try {
        const result = await this.run_action_2('get_pdf_url', { path: this.localData.pdf_path });
        if (result && result.url) {
          this.localData.pdf_url = result.url;
          this.update();
        }
      } catch (error) {
        console.error('Error getting PDF URL:', error);
      }
    }

    // Start polling if state is pending
    if (this.localData.state === 'pending') {
      this.startPolling();
    }
  },
  beforeDestroy() {
    this.stopPolling();
  },
  watch: {
    'localData.state': function(newState, oldState) {
      if (newState === 'pending' && oldState !== 'pending') {
        this.startPolling();
      } else if (newState !== 'pending' && this.pollingInterval) {
        this.stopPolling();
      }
    }
  },
  methods: {
    startPolling: function() {
      if (this.pollingInterval) return; // Already polling
      console.log('Starting polling for pending state');
      this.pollingInterval = setInterval(() => {
        if (this.localData.state === 'pending') {
          console.log('Polling: reloading albaran');
          this.run_action('reload');
        } else {
          this.stopPolling();
        }
      }, 3000);
    },
    stopPolling: function() {
      if (this.pollingInterval) {
        console.log('Stopping polling');
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    handleSave: function() {
      if (this.saving) return; // Prevent multiple clicks
      this.saving = true;
      this.run_action('save');
      // Reset after 1 second
      setTimeout(() => {
        this.saving = false;
      }, 1000);
    },
    addLine: function() {
      if (!this.localData.lines) {
        this.\$set(this.localData, 'lines', []);
      }
      this.localData.lines.push({
        product_code: '',
        concept: '',
        quantity: 1,
        unit_price: 0,
        discount: 0,
        tax_percent: 21,
        tax_amount: 0,
        total: 0
      });
      this.update();
    },
    removeLine: function(index) {
      this.localData.lines.splice(index, 1);
      this.update();
    },
    // Calculate base: quantity * unit_price - discount
    calculateBase: function(line) {
      const quantity = parseFloat(line.quantity) || 0;
      const unitPrice = parseFloat(line.unit_price) || 0;
      const discount = parseFloat(line.discount) || 0;
      return (quantity * unitPrice) - discount;
    },
    // Calculate expected taxes based on percentage
    calculateExpectedTaxes: function(line) {
      const base = this.calculateBase(line);
      const taxPercent = parseFloat(line.tax_percent) || 0;
      return base * (taxPercent / 100);
    },
    // Calculate expected total: base + taxes
    calculateExpectedTotal: function(line) {
      const base = this.calculateBase(line);
      const taxes = parseFloat(line.tax_amount) || 0;
      return base + taxes;
    },
    // Check if taxes match the percentage
    isTaxesValid: function(line) {
      const actualTaxes = parseFloat(line.tax_amount) || 0;
      const expectedTaxes = this.calculateExpectedTaxes(line);
      return Math.abs(actualTaxes - expectedTaxes) <= this.tolerance;
    },
    // Check if total is correct: qty * price - discount + taxes = total
    isTotalValid: function(line) {
      const actualTotal = parseFloat(line.total) || 0;
      const expectedTotal = this.calculateExpectedTotal(line);
      return Math.abs(actualTotal - expectedTotal) <= this.tolerance;
    },
    // Check if line has any error
    hasLineError: function(line) {
      return !this.isTaxesValid(line) || !this.isTotalValid(line);
    },
    formatCurrency: function(value) {
      const num = parseFloat(value) || 0;
      return num.toFixed(2) + ' €';
    },
    correctTotal: function() {
      this.localData.total = this.totalGeneral;
      this.update();
    },
    correctTotalCalculated: function() {
      this.localData.total = Math.round(this.totalGeneralCalculated * 100) / 100;
      this.update();
    },
    correctLineTaxes: function(line) {
      line.tax_amount = Math.round(this.calculateExpectedTaxes(line) * 100) / 100;
      this.update();
    },
    correctLineTotal: function(line) {
      line.total = Math.round(this.calculateExpectedTotal(line) * 100) / 100;
      this.update();
    },
    togglePdfPanel: function() {
      this.showPdfPanel = !this.showPdfPanel;
    },
    openPdfNewTab: function() {
      if (this.localData.pdf_url) {
        window.open(this.localData.pdf_url, '_blank');
      }
    },
    confirmValidar: function() {
      this.showConfirmDialog = true;
    },
    doValidar: function() {
      this.showConfirmDialog = false;
      this.run_action('validar');
    },
    // Convert yyyy-mm-dd from input to dd/mm/yyyy for storage
    setDateFromInput: function(val) {
      if (!val) {
        this.localData.date = '';
      } else if (val.match(/^d{4}-d{2}-d{2}\$/)) {
        // Convert from yyyy-mm-dd to dd/mm/yyyy
        const parts = val.split('-');
        this.localData.date = parts[2] + '/' + parts[1] + '/' + parts[0];
      } else {
        this.localData.date = val;
      }
      this.update();
    },
    // Parse number accepting both . and , as decimal separator
    parseNumber: function(value) {
      if (typeof value === 'number') return value;
      if (!value) return 0;
      // Replace comma with dot and parse
      return parseFloat(String(value).replace(',', '.')) || 0;
    }
  }
};`
